import { NgModule } from '@angular/core'

import { CentralizedButtonComponent } from './centralized-button.component'
import { ConfigModule } from '@spartacus/core'
import { RouterModule } from '@angular/router'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { LinkModule } from '../link/link.module'

@NgModule({
  declarations: [CentralizedButtonComponent],
  imports: [
    CmsComponentsBaseModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        centralized_button: { component: () => import('./centralized-button.component').then(m => m.CentralizedButtonComponent) }
      }
    }),
    LinkModule
  ],
  exports: [CentralizedButtonComponent]
})
export class CentralizedButtonModule {
}
